// localStorage bez wyjątków (zablokowane dane witryny, tryb prywatny).
export function safeGetItem(key) {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeSetItem(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* brak zapisu nie może przewracać aplikacji */
  }
}
